(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/async-component/assets/javascripts/async-route.js') >= 0) return;  svs.modules.push('/components/app/async-component/assets/javascripts/async-route.js');
"use strict";

const _excluded = ["component", "loader", "timeout"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


((svs, React, PropTypes, ReactRouterDOM) => {
  const {
    Route
  } = ReactRouterDOM;
  class AsyncRoute extends React.Component {
    constructor(props) {
      super(props);
      _defineProperty(this, "state", {
        component: null,
        error: null,
        hasTimedOut: false,
        noCache: false
      });
      this.timer = null;
      this.renderRoute = this.renderRoute.bind(this);
      this.handleRetry = this.handleRetry.bind(this);
    }
    componentDidMount() {
      this.resolveComponent();
    }
    componentDidUpdate() {
      if (!this.timer && !this.state.component && !this.state.hasTimedOut && !this.state.error) {
        this.resolveComponent();
      }
    }
    componentWillUnmount() {
      clearTimeout(this.timer);
    }
    resolveComponent() {
      this.props.component({
        noCache: this.state.noCache
      }, (error, Component) => {
        setTimeout(() => {
          clearTimeout(this.timer);
          this.timer = null;
          if (error) {
            this.setState({
              error
            });
            return;
          }
          this.setState({
            component: Component,
            hasTimedOut: false
          });
        });
      });
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.setState({
            hasTimedOut: true
          });
          this.timer = null;
        }, this.props.timeout);
      }
    }
    handleRetry() {
      this.setState({
        error: null,
        hasTimedOut: false,
        noCache: true
      });
    }
    renderRoute(routeProps) {
      if (this.state.error) {
        return React.createElement(this.props.loader, {
          error: this.state.error
          ,
          retry: this.handleRetry
        });
      }
      if (this.state.hasTimedOut) {
        return React.createElement(this.props.loader, {
          retry: this.handleRetry,
          timeout: true
        });
      }
      if (!this.state.component) {
        return React.createElement(this.props.loader, null);
      }
      return React.createElement(this.state.component, routeProps);
    }
    render() {
      const _this$props = this.props,
        {
          component,
          loader,
          timeout
        } = _this$props,
        routeProps = _objectWithoutProperties(_this$props, _excluded);
      return React.createElement(Route, _extends({
        render: this.renderRoute
      }, routeProps));
    }
  }
  AsyncRoute.defaultProps = {
    timeout: 1000
  };
  svs.app.asyncComponent.AsyncRoute = AsyncRoute;
})(svs, React, PropTypes, ReactRouterDOM);

 })(window);